// Web stub for react-native-permissions
// On web, we simulate permission checks always granted

export const PERMISSIONS = {
  ANDROID: {
    CAMERA: 'android.permission.CAMERA',
    RECORD_AUDIO: 'android.permission.RECORD_AUDIO',
    ACCESS_FINE_LOCATION: 'android.permission.ACCESS_FINE_LOCATION',
    ACCESS_COARSE_LOCATION: 'android.permission.ACCESS_COARSE_LOCATION',
  },
  IOS: {
    CAMERA: 'ios.permission.CAMERA',
    PHOTO_LIBRARY: 'ios.permission.PHOTO_LIBRARY',
  },
};

export const RESULTS = {
  GRANTED: 'granted',
  DENIED: 'denied',
  BLOCKED: 'blocked',
  UNAVAILABLE: 'unavailable',
};

// Request permission - on web, always grant
export const request = async (permission: string) => {
  return RESULTS.GRANTED;
};

// Check permission - on web, always assume granted
export const check = async (permission: string) => {
  return RESULTS.GRANTED;
};

// Open app settings - no-op on web
export const openSettings = async () => {
  return null;
};

export default {
  PERMISSIONS,
  RESULTS,
  request,
  check,
  openSettings,
};
